import { render, staticRenderFns } from "./XSidebarMenuItem.vue?vue&type=template&id=34f5b253"
import script from "./XSidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./XSidebarMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports